module.exports = __webpack_public_path__ + "media/images/payments/stripe-dbfca214cfe8f989857e7df3fb867c15.svg";